'use strict';

var cov_1nr3anwqbr = function () {
  var path = 'D:\\raw\\vina_giaitri365\\vnp_365_client\\src\\app\\xvideo\\xvideo.js',
      hash = 'ee2560969d816a25390b8b2f06abdfdda8a6e0db',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\raw\\vina_giaitri365\\vnp_365_client\\src\\app\\xvideo\\xvideo.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 15
        },
        end: {
          line: 3,
          column: 19
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 30
        }
      },
      '2': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 7,
          column: 6
        }
      },
      '3': {
        start: {
          line: 6,
          column: 6
        },
        end: {
          line: 6,
          column: 41
        }
      },
      '4': {
        start: {
          line: 11,
          column: 0
        },
        end: {
          line: 19,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 124
          },
          end: {
            line: 8,
            column: 3
          }
        },
        line: 2
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 5,
            column: 19
          },
          end: {
            line: 5,
            column: 20
          }
        },
        loc: {
          start: {
            line: 5,
            column: 31
          },
          end: {
            line: 7,
            column: 5
          }
        },
        line: 5
      }
    },
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0
    },
    f: {
      '0': 0,
      '1': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var XvideoController = function XvideoController($scope, $http, $stateParams, $state, myVars, $mdDialog, ngNotify, $location, PageViews, $mdMedia, $rootScope) {
  _classCallCheck(this, XvideoController);

  cov_1nr3anwqbr.f[0]++;

  var self = (cov_1nr3anwqbr.s[0]++, this);
  cov_1nr3anwqbr.s[1]++;
  $scope.checkinfo = myVars;
  cov_1nr3anwqbr.s[2]++;
  this.$onInit = function () {
    cov_1nr3anwqbr.f[1]++;
    cov_1nr3anwqbr.s[3]++;

    self.myScopeObject = self.clipData;
  };
};

cov_1nr3anwqbr.s[4]++;


angular.module('app').component('secureview', {
  templateUrl: 'app/xvideo/xvideo.html',
  controller: XvideoController,
  bindings: {
    clipData: '<'
  }
});